import React, { useState } from 'react';
import Cookies from 'universal-cookie';
import { useSelector } from 'react-redux';
import announcementIcon from './announcement-icon.png';
import styles from './myecriannoucement.module.scss';
import { AppState } from '../../store';
import { hashString } from '../../util/hash';

const MY_ECRI_COOKIE_ANNOUNCMENT_NAME = 'meannouncement';
const maxDate = new Date(8640000000000000);

const MyEcriAnnouncement: React.FC = () => {
  const [isHidden, setIsHidden] = useState<boolean>(false);
  const myEcriAnnouncement = useSelector(
    (x: AppState) => x.announcement.myEcriAnnouncement
  );

  if (myEcriAnnouncement === null) {
    return null;
  }

  if ((myEcriAnnouncement.formattedText ?? '') === '') {
    return null;
  }
  if (isHidden) {
    return null;
  }
  const cookie = new Cookies();

  const c = cookie.get<string>(MY_ECRI_COOKIE_ANNOUNCMENT_NAME);
  if (parseInt(c, 10) === hashString(myEcriAnnouncement.formattedText ?? '')) {
    return null;
  }
  return (
    <div className={styles.myEcriAnnouncementContainer}>
      <img
        className={styles.announcementIcon}
        src={announcementIcon}
        alt="Announcement"
      ></img>
      <div className={styles.announcementBody}>
        <div
          dangerouslySetInnerHTML={{
            __html: myEcriAnnouncement.formattedText ?? '',
          }}
        />
      </div>
      <span
        className={styles.closeAnnouncementButton}
        onClick={() => {
          cookie.set(
            MY_ECRI_COOKIE_ANNOUNCMENT_NAME,
            hashString(myEcriAnnouncement.formattedText ?? ''),
            {
              path: '/',
              expires: maxDate,
              maxAge: 9000000000,
            }
          );
          setIsHidden(true);
        }}
      >
        X
      </span>
    </div>
  );
};

export default MyEcriAnnouncement;
